module.exports = __webpack_public_path__ + "static/media/tds_scotland.21510660.png";